import React, { useEffect, useRef } from "react";

export default function DocxViewer({ blob }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (blob && containerRef.current) {
      const renderDocx = async () => {
        try {
          const arrayBuffer = await blob.arrayBuffer();
          await window.docx.renderAsync(arrayBuffer, containerRef.current, null, {
            ignoreLastRenderedPageBreak: false,
          });
        } catch (err) {
          console.error("Erro ao renderizar DOCX:", err);
        }
      };

      renderDocx();
    }
  }, [blob]);

  return (
    <div
      ref={containerRef}
      style={{
        border: "1px solid #ccc",
        padding: "16px",
        height: "70vh",
        overflow: "scroll",
        overflowWrap: "break-word",
      }}
    />
  );
}
